import React from 'react';
import { Chip } from '@mui/material';
import type { Priority } from '../types/models';

const priorityColors: Record<Priority, { bg: string; color: string }> = {
  Critical: { bg: 'rgba(255, 82, 82, 0.15)', color: '#FF5252' },
  High: { bg: 'rgba(255, 183, 77, 0.15)', color: '#FFB74D' },
  Medium: { bg: 'rgba(108, 155, 255, 0.15)', color: '#6C9BFF' },
  Low: { bg: 'rgba(105, 240, 174, 0.15)', color: '#69F0AE' },
};

export default function PriorityChip({ priority }: { priority: Priority }) {
  const style = priorityColors[priority] || priorityColors.Medium;
  return (
    <Chip
      label={priority}
      size="small"
      sx={{ bgcolor: style.bg, color: style.color, fontWeight: 600 }}
    />
  );
}
